<template>
    <div class="modal-body">

        <template v-for="(item, index) in items">

            <!-- control_item -->
            <div class="row control_item underlined_item">
                <div class="col-12 col-md-9 col-xl-10 mt_xxs">

                    <div class="media control_group">
                        <div class="control_action">
                            <button v-if="checkable" href="#" class="btn btn_lg btn_common btn_icontext"
                                @click.prevent="choosePickupPoint(item.id, item.name, item.address)">
                                <i class="f7-icons icon_lg">
                                    {{ address.id == item.id ? 'checkmark_alt_circle_fill' : 'checkmark_alt_circle' }}
                                </i>
                                    {{ address.id == item.id ? 'Выбрано' : 'Выбрать' }}
                            </button>
                        </div>

                        <div class="media-body">
                            <div class="control_title subtitle">{{ item.name}}</div>

                            <div class="control_small small_info">
                                <span class="other_xs">{{ item.address}}</span>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-12 col-md-3 col-xl-2 mt_xxs">

                    <div class="control_change ">
                        <div>
                            <!-- <button class="btn btn_sm btn_neutral"
                                @click.prevent="deleteAddress(item.id)">Удалить</button> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- //control_item -->

        </template>

    </div>
</template>

<script>
export default {
    props: {
        checkable: {
            default: true,
            type: Boolean,
        }
    },
    data: function () {
        return {
        }
    },
    methods: {
        choosePickupPoint(id, name, address) {
            this.$store.dispatch("order/choosePickupPoint", {id, name, address});
            document.getElementById("modalPickupPointClose").click();
        }
    },
    computed: {
        // Массив адресов
        items() {
            // Если способ доставки "Пункт самовывоза заказов", то выводятся точки выдачи
            // Иначе - адреса клиента
            if (this.$store.state.order.delivery.id) {
                let delivery = this.$store.state.delivery.deliveries.find(
                    (value, index) => {
                        return value.id == this.$store.state.order.delivery.id;
                    }
                );

                if (typeof delivery.points !== "undefined") {
                    return delivery.points;
                }
            }

            return [];
        },

        // Выбранный адрес
        address() {
            return this.$store.state.order.pickup_point;
        },
    },
};
</script>
